import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { ProductosService } from '../../../../services/productos.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
import { ConstantsService } from '../../../../services/constants.service';

@Component({
  selector: 'app-formulario-fotografias-producto',
  templateUrl: './formulario-fotografias-producto.component.html',
  styleUrls: ['./formulario-fotografias-producto.component.scss']
})
export class FormularioFotografiasProductoComponent implements OnInit {
  @Input() id_producto: number = null;
  @Output() fotoSubida: EventEmitter<any[]> = new EventEmitter;

  //Modelos
  public fotos: any[] = [];

  //helpers
  public uploading: boolean = false;
  public loading: boolean = null;
  public api_url:string = '';
    
  constructor(private produtosService: ProductosService,
    private helperService: HelpersService,
    private constantsService: ConstantsService) {
      this.api_url = constantsService.apiURL;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    
    //En caso de tener cargadas las fotos de otro producto las inicializamos
    this.fotos=[];

    if (changes.id_producto && this.id_producto) {
      this.cargarFotos();
    }
  }

  public subirArchivo($event){
    if ($event.target.files.length == 0) {
      return;
    }

    let archivo = $event.target.files[0];
    
    this.uploading = true;
    this.produtosService.subirFoto(this.id_producto, archivo)
    .subscribe(
        (response)=>{
          this.uploading = false;
          let fontoSubida = response.json().content;

          //Actualizar lista de fotos
          if(this.id_producto){
            this.cargarFotos();
          }else{
            this.fotos.push(fontoSubida);
            //Le mandamos al formulario de productos las fotos que se han subido, para que las confirme al crear el producto
            this.fotoSubida.emit(this.fotos);
          }
        },
        (error)=>{
          this.uploading = true;
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          if(error.status == 400) {
            alert("ERROR: "+JSON.stringify(error));
          }
        }
    );
    
  }

  public eliminarFoto(foto){
    foto.deleting = true;
    this.produtosService.eliminarFoto(foto.id_producto_foto)
    .subscribe(
        (response)=> {
          foto.deleting = false;
          let content = response.json().content;
          
          //Actualizar lista de fotos
          if(this.id_producto){
            this.cargarFotos();
          }else{
            this.eliminarFotoDelArreglo(foto, this.fotos);
            //Le mandamos al formulario de productos las fotos que se han subido, para que las confirme al crear el producto
            this.fotoSubida.emit(this.fotos);
          }
        },
        (error) => {
          foto.deleting = false;
        }
    );
  }

  public cargarFotos(){
    this.loading = true;
    this.produtosService.listarFotos({ id_producto: this.id_producto})
    .subscribe(
        (response)=> {
            this.loading = false;
            let content = response.json().content;
            this.fotos = content;        
        },
        (error) => {
          this.loading = false;
        }
    );
  }

  private eliminarFotoDelArreglo(foto, arregloFotos){
    let index=0;
    let salirDelCiclo = false;
    while(index < arregloFotos.length && !salirDelCiclo){
      if(foto.id_producto_foto === arregloFotos[index].id_producto_foto){
        //Elimino el item del arreglo
        arregloFotos.splice(index, 1);
        salirDelCiclo = true;
      }
      index++;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/catalogo-productos/formulario-producto/formulario-fotografias-producto/formulario-fotografias-producto.component.ts